module.exports = __webpack_public_path__ + "img/mallNull.1dec6456.png";